import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    addFund: {
        id: 'cards.add_funds.title',
        defaultMessage: 'Add funds',
    },
    receiveTitle: {
        id: 'cards.add_funds.receive.title',
        defaultMessage: 'Receive',
    },
    receiveDescription: {
        id: 'cards.add_funds.receive.description',
        defaultMessage: 'Add {currencyCode} to your wallet',
    },
    swapTitle: {
        id: 'cards.add_funds.swap.title',
        defaultMessage: 'Swap',
    },
    swapDescription: {
        id: 'cards.add_funds.swap.description',
        defaultMessage: 'Convert wallet assets to {currencyCode}',
    },
})
